import { useCallback as e } from "react";
import { useTranslation as t } from "react-i18next";
import { PARTNER_PRICING_UNAVAILABLE as n } from "@maat/api-shared";
//#region src/enums/useTrQuoteUnavailable.ts
var r = "PRICELABS_PRICING_UNAVAILABLE", i = "PRICELABS_CURRENCY_RECALIBRATING", a = (e) => e === r || e === i || e === n, o = (e) => e === i ? "checkout.externalPricing.recalibrating" : "checkout.externalPricing.unavailable", s = () => {
	let { t: n } = t("booking");
	return e((e) => {
		if (!e) return;
		let t = e?.response?.data?.code;
		return a(t) ? n(o(t)) : n("checkout.externalPricing.generic");
	}, [n]);
};
//#endregion
export { a as isQuoteUnavailableCode, o as quoteUnavailableCopyKey, s as useTrQuoteUnavailable };
